// Shared by Tailwind, viewport CSS generation, and React. Device dimensions
// keep phone identity stable through rotation and keyboard viewport resizing.
module.exports = {
  PHONE_LAYOUT_QUERY: '(max-width: 639px), (hover: none) and (pointer: coarse) and (max-device-width: 639px), (hover: none) and (pointer: coarse) and (max-device-height: 639px)',
  WIDE_LAYOUT_QUERY: '(min-width: 640px) and (hover: hover), (min-width: 640px) and (pointer: fine), (min-width: 640px) and (pointer: none), (min-width: 640px) and (min-device-width: 640px) and (min-device-height: 640px)',
};
